import React, {Fragment, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {history} from "_helpers";
import {tiktokShopActions} from "_actions";
import {Loading} from "../../../../../common";
import * as Sentry from '@sentry/react';

export default function TikTokShopUrlRedirect() {
    const dispatch = useDispatch();
    const url = new URL(document.location);
    const values = new URLSearchParams(url.search);
    const authCode = values.get('code');
    const state = values.get('state');

    useEffect(() => {
        if (authCode && state) {
            const params = {authCode, state};
            dispatch(tiktokShopActions.createAccount(params));
        } else {
            Sentry.captureException(new Error("Cannot find code/state in the redirect URL from TikApi (Shop). URL: " + url));
        }
    }, []);

    const tiktokShop = useSelector((state) => state.tiktokShop);

    if (tiktokShop.authLoading) {
        return <Loading />;
    }

    history.push('/company/connectchannels');

    return(
        <Fragment/>
    )
}